/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_INFO, ICON_REPORT, ICON_WARNING } from '@squiz/sds';
import { LogLevel } from 'apps/console-core/src/Services/logging';

export const getLogLevelIcon = (level: LogLevel): JSX.Element => {
  switch (level) {
    case LogLevel.ERROR:
      return ICON_REPORT;
    case LogLevel.WARNING:
      return ICON_WARNING;
    case LogLevel.INFO:
    default:
      return ICON_INFO;
  }
};
